import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapKeyShoutToContentTableItems(
	activeShouts: KeyShout[],
	draftShouts: KeyShout[]
): ContentTableItem[] {
	const live = [...activeShouts]
		.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
		.map((shout, index) => ({
			id: shout.id,
			name: shout.heading,
			createdBy: shout.createdBy
				? `${shout.createdBy.firstName} ${shout.createdBy.lastName}`
				: undefined,
			lastUpdated: shout.updatedAt ?? shout.createdAt,
			isActive: true,
			order: index + 1
		}));

	const draft = draftShouts.map((shout) => ({
		id: shout.id,
		name: shout.heading,
		createdBy: shout.createdBy
			? `${shout.createdBy.firstName} ${shout.createdBy.lastName}`
			: undefined,
		lastUpdated: shout.updatedAt ?? shout.createdAt,
		isActive: false
	}));

	return [...live, ...draft];
}
